import React from "react";
import styled from "styled-components";
import { colors } from "../../theme/color";

interface LineConnectorProps {
  totalSubSteps: number;
  activeSubStep: number;
}

const LineConnector: React.FC<LineConnectorProps> = ({
  totalSubSteps,
  activeSubStep,
}) => {
  const progressHeight = `${(activeSubStep / totalSubSteps) * 100}%`;
  const totalHeight = `${totalSubSteps * 25}px`;

  return (
    <ConnectorWrapper $totalHeight={totalHeight}>
      <BackgroundLine />
      <ProgressLine style={{ height: progressHeight }} />
    </ConnectorWrapper>
  );
};

export default LineConnector;

const ConnectorWrapper = styled.div<{ $totalHeight: string }>`
  position: relative;
  padding-left: 1.5rem;
  height: ${({ $totalHeight }) => $totalHeight};
`;

const BackgroundLine = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background-color: ${colors.neutral.oldSilver};
`;

const ProgressLine = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 3px;
  background-color: ${colors.secondary.islamicGreen};
  transition: height 0.3s ease-in-out;
`;
